import { EvidenceItemParams } from '@/backend/access/evidenceItem/types';
import { RequirementCategoryType } from '@/backend/access/requirementEvidenceCategory/types';
import { File } from './file';

export class EvidenceItem {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  projectId: string;
  propelOrgId: string;
  title: string;
  description?: string | null;
  type: RequirementCategoryType;
  file: File;

  constructor(params: EvidenceItemParams) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.projectId = params.projectId;
    this.propelOrgId = params.propelOrgId;
    this.title = params.title;
    this.description = params.description;
    this.type = params.type;
    this.file = new File(params.file);
  }
}
